import { gql } from 'apollo-boost'

export const TASK_VIEW_FIELDS = gql`
  fragment TaskViewFields on TaskView {
    id
    type
    status
    modifiedBrandFields
    modifiedLocationIds
    resolvedBy {
      id
      name
    }
    resolvedDate
  }
`
